import React, { useState } from 'react'
import { startCase } from 'lodash'
import { fetchTrendingSearchContentBlocks } from 'shared/api'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import { giphyIndigo } from '@giphy/js-brand'
import { IContentBlock } from './types'
import Blocks from './components/blocks'
import { ContentBlockContext } from './context'

type Props = {
    className?: string
    width?: number
}

const PopularSearchesContentBlock = ({ className, width }: Props) => {
    const [blocks, setBlocks] = useState<IContentBlock[]>([])

    useAsyncEffect(async () => {
        const { results } = await fetchTrendingSearchContentBlocks()
        setBlocks(
            results.map(({ term, gif }) => ({
                id: `search-${term.replace(/ /g, '-')}`,
                url: `/search/${encodeURIComponent(term)}`,
                label: startCase(term),
                gif,
            }))
        )
    }, [])

    return (
        <ContentBlockContext.Provider
            value={{
                title: 'Popular Searches',
                labelColor: giphyIndigo,
                iconClassName: 'ss-search',
                width,
            }}
        >
            <Blocks blocks={blocks} className={className} />
        </ContentBlockContext.Provider>
    )
}

export default PopularSearchesContentBlock
